export const MENU_ITEMS = [
  {
    id: 'avant le départ',
    title: 'Checklist avant le départ',
    cards: [
      {
        title: 'Débuter',
        icon: '📶',
        color: '#2563eb',
        content: [
          'VPN & connection Internet - Installer et tester un VPN',
          'Communiquer sans Internet',
        ],
        link: '/login',
      },
      {
        title: 'Payer',
        icon: '💳',
        color: '#2563eb',
        content: [
          'Les applications indispensables pour payer',
          'Informer sa banque de son séjour en Chine',
          'Argent liquide',
        ],
        link: '/login',
      },
      {
        title: 'Smartphone',
        icon: '📱',
        color: '#2563eb',
        content: ['Smartphone et batterie de téléphone'],
        link: '/login',
      },
      {
        title: 'Communiquer',
        icon: '💬',
        color: '#2563eb',
        content: ['Apps indispensable'],
        link: '/login',
      },
      {
        title: 'Hotel & Trains',
        icon: '🚉',
        color: '#2563eb',
        content: ['Reservation'],
        link: '/login',
      },
      {
        title: 'Formalités douanières',
        icon: '📋',
        color: '#2563eb',
        content: ['Préparer passeport et visa', 'Préparer le motif du séjour'],
        link: '/login',
      },
      {
        title: 'Smartphone',
        icon: '📱',
        color: '#2563eb',
        content: ['Un téléphone pour le VPN, un pour le quotidien'],
        link: '/login',
      },
    ],
  },
  {
    id: 'avion',
    title: 'Douane & formalités',
    cards: [
      {
        title: 'Formalités',
        icon: '🛂',
        color: '#2563eb',
        content: ['Remplir la fiche d’arrivée distribuée dans l’avion'],
        link: '/login',
      },
      {
        title: 'Taxi(Uber) DiDi',
        icon: '🎒',
        color: '#2563eb',
        content: [
          "Installer l'application DiDi",
          'Trouver la zone de prise en charge DiDi',
          'Commander un taxi',
        ],
        link: '/login',
      },
      {
        title: 'Se deplacer en train',
        icon: '🎒',
        color: '#2563eb',
        content: [
          'Acheter un billet de train',
          "S'orienter à la gare de train",
        ],
        link: '/login',
      },
    ],
  },
  {
    id: 'Produits',
    title: 'Fournisseurs & Transitaires',
    subtitle:
      'Nous pouvons vous accompagner pour vos achats, vous mettre en contact avec les forunisseurs, accompagner pour le transport jusque dans votre pays.',
    cards: [
      {
        title: 'Materiaux de constructions',
        icon: '🛂',
        color: '#2563eb',
        content: [
          'Menuiseries Portes & Fenêtres',
          'Sanitaires',
          'Eviers',
          'Clims & Electroménagers',
          'Meubles de salons & salle à manger',
        ],
        link: '/login',
      },
      {
        title: 'Machines de construction & Agricoles',
        icon: '🎒',
        color: '#2563eb',
        content: [
          'Achat de bétonnières',
          'Achat de machines pour férailleurs',
          'Achat de machines agricoles',
        ],
        link: '/login',
      },
      {
        title: 'Véhicules',
        icon: '🎒',
        color: '#2563eb',
        content: [
          'Achat de vehicules neufs',
          "Achat de vehicules d'occasions",
          'Achat de machines agricoles',
        ],
        link: '/login',
      },
      {
        title: 'Transitaires',
        icon: '🎒',
        color: '#2563eb',
        content: [
          'Vehicules neufs',
          "Vehicules d'occasions",
          'Machines agricoles',
        ],
        link: '/login',
      },
    ],
  },
  {
    id: 'Simulateur',
    title: 'Simulateurs des droits de douane',
    subtitle:
      "Nous vous fournissons un outil pour générer la liste des produits et simuler l'attestation de verification documentaire(AVD) afin d'évaluer si votre décision d'achéter à l'étranger est rentable.",
    cards: [
      {
        title: 'Materiaux de constructions',
        icon: '🛂',
        color: '#2563eb',
        content: ['Simulateurs des droits de douane'],
        link: '/login',
      },
    ],
  },
  {
    id: 'Contact',
    title: 'Nous contacter',
    subtitle:
      "Nous vous fournissons un outil pour générer la liste des produits et simuler l'attestation de verification documentaire(AVD) afin d'évaluer si votre décision d'achéter à l'étranger est rentable.",
    cards: [
      {
        title: 'Parlons de votre projet',
        icon: '🛂',
        color: '#2563eb',
        content: [
          "Que vous soyez un particulier, une entreprise, une administration ou un professionnel du transport et de la logistique en Afrique de l'Ouest, notre expertise vous aide à estimer avec précision vos droits et taxes d'importation afin de mieux planifier et sécuriser votre projet.",
        ],
        link: '/contact',
      },
    ],
  },
]
// Fichier généré automatiquement
